import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faArrowLeft,
  faExclamationTriangle,
  faSearch,
  faLayerGroup,
  faRocket,
  faBolt,
  faFire,
  faGem
} from '@fortawesome/free-solid-svg-icons';
import styles from './NoMatch.module.scss';
import WelcomeHeader from '../WelcomePage/components/WelcomeHeader/WelcomeHeader';

function NoMatch() {
  const navigate = useNavigate();
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    // Генерация частиц для фона
    const newParticles = [];
    for (let i = 0; i < 50; i++) {
      newParticles.push({
        id: i,
        left: Math.random() * 100,
        top: Math.random() * 100,
        size: Math.random() * 4 + 2,
        duration: Math.random() * 20 + 10,
        delay: Math.random() * 5
      });
    }
    setParticles(newParticles);
  }, []);

  const handleOpenService = (serviceId) => {
    navigate(`/service/${serviceId}`);
  };

  const handleNavigate = (page) => {
    navigate(`/${page}`);
  };

  const quickLinks = [
    // { icon: faLayerGroup, text: 'Все сервисы', path: '/services' },
    { icon: faRocket, text: 'Главная', path: '/' },
    { icon: faSearch, text: 'Поиск', path: '/search' }
  ];

  return (
    <div className={styles.notfoundPage}>
      {/* Ваш идеальный хедер */}
      {/* <WelcomeHeader 
        goBack={() => navigate('/')}
        onOpenProfile={() => navigate('/profile')}
        onOpenService={handleOpenService}
        onNavigate={handleNavigate}
      /> */}

      {/* Анимированный фон */}
      <div className={styles.backgroundAnimation}>
        {particles.map(particle => (
          <div
            key={particle.id}
            className={styles.particle}
            style={{
              left: `${particle.left}%`,
              top: `${particle.top}%`,
              width: `${particle.size}px`,
              height: `${particle.size}px`,
              animationDuration: `${particle.duration}s`,
              animationDelay: `${particle.delay}s`
            }}
          />
        ))}
        <div className={styles.gradientOrb1} />
        <div className={styles.gradientOrb2} />
        <div className={styles.gradientOrb3} />
      </div>

      {/* Основной контент */}
      <div className={styles.content}>
        <div className={styles.container}>
          
          {/* Главный блок с ошибкой */}
          <div className={styles.errorBlock}>
            <div className={styles.iconWrapper}>
              <FontAwesomeIcon icon={faExclamationTriangle} className={styles.warningIcon} />
              <div className={styles.iconGlow} />
            </div>

            <div className={styles.errorNumber}>
              <span className={styles.digit}>4</span>
              <span className={styles.digitZero}>0</span>
              <span className={styles.digit}>4</span>
            </div>

            <h1 className={styles.title}>
              <FontAwesomeIcon icon={faBolt} className={styles.boltIcon} />
              Страница не найдена
              <FontAwesomeIcon icon={faBolt} className={styles.boltIcon} />
            </h1>

            <p className={styles.description}>
              К сожалению, запрашиваемая страница не существует или была перемещена.
              <br />
              Но не переживайте, мы поможем вам найти нужный путь!
            </p>

            {/* Кнопки действий */}
            <div className={styles.actions}>
              <button className={styles.primaryBtn} onClick={() => navigate('/')}>
                <FontAwesomeIcon icon={faHome} />
                <span>Вернуться на главную</span>
                <div className={styles.btnGlow} />
              </button>
              
              <button className={styles.secondaryBtn} onClick={() => navigate(-1)}>
                <FontAwesomeIcon icon={faArrowLeft} />
                <span>Назад</span>
              </button>
            </div>
          </div>

          {/* Быстрые ссылки */}
          <div className={styles.quickLinks}>
            <h3 className={styles.quickLinksTitle}>
              <FontAwesomeIcon icon={faFire} />
              Популярные разделы
            </h3>
            <div className={styles.linksGrid}>
              {quickLinks.map((link, index) => (
                <div 
                  key={index}
                  className={styles.linkCard}
                  onClick={() => navigate(link.path)}
                >
                  <div className={styles.linkIcon}>
                    <FontAwesomeIcon icon={link.icon} />
                    <div className={styles.linkIconGlow} />
                  </div>
                  <span className={styles.linkText}>{link.text}</span>
                  <div className={styles.cardShine} />
                </div>
              ))}
            </div>
          </div>

          {/* Декоративный элемент */}
          <div className={styles.decorativeBadge}>
            <FontAwesomeIcon icon={faGem} className={styles.gemIcon} />
            <span>NCORE Platform</span>
          </div>

        </div>
      </div>
    </div>
  );
}

export default NoMatch;
